"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SvgComponent = function SvgComponent(props, ref) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("title", {
      children: "Pin"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "m8.183.044 3.761 3.76a.151.151 0 0 1 0 .214l-1.28 1.28a.15.15 0 0 1-.214 0l-.364-.363-1.688 1.688a4.278 4.278 0 0 1-1.188 4.205c-.098.093-.083.093-.177-.002l-2.39-2.389L0 11.987l3.551-4.642-2.393-2.393c-.095-.095-.087-.08.007-.179a4.278 4.278 0 0 1 4.2-1.183l1.688-1.688-.364-.364a.152.152 0 0 1 0-.213L7.97.044a.152.152 0 0 1 .214 0Z",
      fill: "currentColor",
      fillRule: "nonzero"
    })]
  }));
};

var ForwardRef = /*#__PURE__*/(0, React.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Pin.js.map